import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  Box,
  Typography
} from '@material-ui/core';
import { CloseIcon, QueryBuilder } from 'components';
import { Alert } from '@material-ui/lab';
import SaveMessage from 'views/UserMessaging/customModalContent/saveMessage';
import Skeleton from 'react-loading-skeleton';

const useStyles = makeStyles(theme => ({
  root: {},
  cardActions: {
    flexDirection: 'row'
  },
  templateButtonError: {
    paddingLeft: '19px',
    color: theme.palette.error.main
  },
  saveButton: {
    marginLeft: '14px !important'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%'
  }
}));

const Design = props => {
  const {
    className,
    staticContext,
    template,
    back,
    showNav,
    isPopupDialog,
    ...rest
  } = props;
  const {
    goBack,
    navBackOnError,
    shouldShowError,
    attributes,
    thisTemplate,
    isQueryReadOnly,
    closeQuery,
    saveTemplate,
    isLoading,
    isTemplateSaving,
    updateCurrentErrorValidationSegment,
    handleChange,
    isTemplateSaved
  } = template;

  const classes = useStyles();

  useEffect(() => {
    updateCurrentErrorValidationSegment('design');
  }, [thisTemplate, updateCurrentErrorValidationSegment]);

  useEffect(() => {
    navBackOnError(back);
  }, [thisTemplate]);

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          {!isPopupDialog && (
            <React.Fragment>
              <div>
                {isQueryReadOnly() && (
                  <Alert severity="info">
                    You do not have access to edit this query. Tenant Default
                    queries can be edited only with 'ALL' property.
                  </Alert>
                )}
              </div>
              <div className={classes.headerContainer}>
                <div className={classes.title}>
                  <CardHeader
                    title="Condition Queries"
                    titleTypographyProps={{ variant: 'h1' }}
                  />
                </div>
                <CloseIcon onClickClose={closeQuery} />
              </div>
            </React.Fragment>
          )}
          <Divider />
          <CardContent>
            {isLoading && (
              <Skeleton
                style={{ marginLeft: '8px' }}
                variant="rectangular"
                width={300}
                height={20}
              />
            )}
            {(!isLoading && thisTemplate.hasMovedToNextStep) && (
              <QueryBuilder
                name="conditionExpression"
                template={{ thisTemplate, attributes }}
                onChange={handleChange}
                isReadOnly={isQueryReadOnly}
                isLoading={isLoading}
                query={thisTemplate.conditionExpression || {}}
                required="true"
              />
            )}
            {(shouldShowError(`conditionExpression.subConditionExpressions`) ||
              shouldShowError(`conditionExpression.valid`)) && (
                <Typography
                  className={classes.templateButtonError}
                  variant="caption"
                  display="block">
                  {shouldShowError(`conditionExpression.subConditionExpressions`)
                    ? '*Please add at least one rule.'
                    : '*Please enter a complete valid expression.'}
                </Typography>
              )}
          </CardContent>
          {(back || showNav || isPopupDialog) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                {!isPopupDialog && (
                  <Button
                    color="secondary"
                    variant="contained"
                    disabled={isLoading || isTemplateSaving}
                    link={back}
                    onClick={goBack}>
                    Back
                  </Button>
                )}
                <Typography></Typography>
                <Box flexGrow={1}>&nbsp;</Box>
                {!isQueryReadOnly() && (
                  <Button
                    className={classes.saveButton}
                    color="primary"
                    variant="contained"
                    disabled={isLoading || isTemplateSaving}
                    onClick={() => saveTemplate()}>
                    Save Query
                  </Button>
                )}
              </CardActions>
            </>
          )}
        </form>
      </Card>
      {<SaveMessage openSnackbar={isTemplateSaved} />}
    </div>
  );
};

export default Design;
